// extracted by mini-css-extract-plugin
module.exports = {"activityCell":"activityCell__e3u9H","content":"content__7c7eF","text":"text__tGRgi","date":"date__vnisd","tooltip":"tooltip__K8AHP","tooltipClassName":"tooltipClassName__oZfWu"};